<div class="container">
  <div class="centered-content amplifyBorders" *ngIf="!canAddSchool && !addingSchool">
    <div *ngIf="currentSchools.length">
      <p>U hebt momenteel de volgende gebruikersrollen binnen deze scholen </p>
      <ul class="school-items" >
        <li *ngFor="let school of currentSchools" >

          <span>
            <span class="name">{{school.name}}: </span>
            <span class="roles-container">
              <span class="roles">
                 <div *ngFor="let role of school.school_roles; let i = index" class="role">
                   <span>{{ getRoleName(role.role) }}</span><span (click)="unlinkSchool(school, role.role)" class="remove">x</span>
                 </div>
              </span>
            </span>
          </span>
        </li>
      </ul>

    </div>
    <div *ngIf="!currentSchools.length" class="warning">
      <p>U bent momenteel nog niet gekoppeld aan een school. Als u al een aanvraag tot verbinding heeft ingediend, vragen we u om geduld te hebben totdat de schoolbeheerder deze heeft goedgekeurd.</p>
    </div>
    <div class="form-group buttons">
      <button class="amplify-button amplify-button--fullwidth amplify-button--medium amplify-button--primary" (click)="canAddSchool = !canAddSchool">Verbind met nieuwe school</button>
      <button *ngIf="currentSchools.length" class="amplify-button amplify-button--fullwidth amplify-button--medium amplify-button--destructive" (click)="back()">Terug</button>
    </div>

  </div>
  <div *ngIf="addingSchool && newSchoolForm">
    <form class="centered-content amplifyBorders" data-amplify-form *ngIf="addingSchool" [formGroup]="newSchoolForm" (ngSubmit)="onSubmitSchool($event)">
      <div class="info">
        <p>Uw verzoek wordt handmatig verwerkt. Wij houden u op de hoogte zodra er een beslissing is genomen.</p>
      </div>
      <div class="form-group">
        <label class="amplify-label" for="school_nr">School nummer</label>
        <input type="text" class="amplify-input" id="school_nr" name="school_nr" formControlName="school_nr">
      </div>
      <div class="form-group">
        <label class="amplify-label" for="name">Naam*</label>
        <input type="text" class="amplify-input" id="name" name="name" formControlName="name">
      </div>
      <div class="form-group">
        <label class="amplify-label" for="address">Adres*</label>
        <input type="text" class="amplify-input" id="address" name="address" formControlName="address">
      </div>
      <div class="form-group">
        <label for="postalCode">Postcode/Gemeente*</label>
        <div class="ng-autocomplete postalCode">
          <ng-autocomplete
            id="postalCode"
            class=""
            [data]="postalData"
            searchKeyword="combined"
            (selected)='selectPostalcode($event)'
            (inputChanged)="searchPostalCode($event)"
            [itemTemplate]="itemTemplate"
            [initialValue]="initialPostal"
            notFoundText="Niet gevonden"
            [selectedValueRender]="selectedPostalRender"
            [notFoundTemplate]="notFoundTemplate">
          </ng-autocomplete>

          <ng-template #itemTemplate let-item>
            <a [innerHTML]=item.combined></a>
          </ng-template>

          <ng-template #notFoundTemplate let-notFound>
            <div [innerHTML]="notFound"></div>
          </ng-template>
        </div>
      </div>
      <div class="form-group">
        <label class="amplify-label" for="country">Land*</label>
        <select class="amplify-select amplify-field-group__control" id="country" formControlName="country" [(ngModel)]="selectedCountry">
          <option *ngFor="let country of countries" [value]="country.code">{{ country.name }}</option>
        </select>
      </div>
      <div class="form-group">
        <label class="amplify-label" for="email">email*</label>
        <input type="email" class="amplify-input" id="email" name="email" formControlName="email">
      </div>
      <div class="form-group">
        <label class="amplify-label" for="phone">Telefoon*</label>
        <input type="text" class="amplify-input" id="phone" name="phone" formControlName="phone">
      </div>
      <div class="form-group">
        <label class="amplify-label" for="website">Website</label>
        <input type="text" class="amplify-input" id="website" name="website" formControlName="website">
      </div>

      <div class="form-group buttons">
        <button type="submit" class="amplify-button amplify-button--fullwidth amplify-button--medium amplify-button--primary" [disabled]="isAddSchoolValid">School toevoegen</button>
        <button *ngIf="currentSchools.length" class="amplify-button amplify-button--fullwidth amplify-button--medium amplify-button--destructive" (click)="addingSchool = false">Terug</button>
      </div>
    </form>
  </div>
  <form class="centered-content amplifyBorders" data-amplify-form *ngIf="schoolForm && canAddSchool && !addingSchool" [formGroup]="schoolForm" (ngSubmit)="onSubmit($event)" >
    <div class="info">
      <p><b>Verbind jouw account met een school.</b> <br>
        Geef aan of u een leerling, leerkracht, secretariaatsmedewerker of administrator bent en bij welke school u hoort. <br>
        Na controle zal de koppeling worden goedgekeurd. <br>
        Het verstrekken van onjuiste gegevens kan leiden tot het verlies van licenties of de deactivering van uw account.</p>
    </div>

    <div class="form-group userRoles">
      <label class="amplify-label" for="school_role">Ik ben</label>
      <select class="amplify-select amplify-field-group__control"
              [(ngModel)]="selectedRole"
              id="school_role" formControlName="school_role">
        <option *ngFor="let role of Object.keys(role_map)" [value]="role_map[role]">{{ role }}</option>
      </select>
    </div>
    <div class="form-group">
      <label for="schoolSearch">School</label>
      <div class="ng-autocomplete postalCode">
        <ng-autocomplete
          id="schoolSearch"
          class=""
          [data]="schoolData"
          placeholder="zoek uw school"
          searchKeyword="name"
          (selected)='selectSchool($event)'
          (inputChanged)="searchSchools($event)"
          (inputCleared)="clearClasses()"
          [itemTemplate]="itemSchoolTemplate"
          notFoundText="Niet gevonden"
          [selectedValueRender]="selectedSchoolRender"
          [notFoundTemplate]="notFoundSchoolTemplate">
        </ng-autocomplete>

        <ng-template #itemSchoolTemplate let-item>
          <a [innerHTML]=item.name></a>
        </ng-template>

        <ng-template #notFoundSchoolTemplate let-notFound>
          <div [innerHTML]="notFound"></div>
        </ng-template>
      </div>
      <p class="no-school"><a (click)="addingSchool = true">Nieuwe school toevoegen</a></p>
    </div>

    <div class="form-group" *ngIf="hasClass && selectedSchool">
      <label class="amplify-label" for="klas">klas</label>
      <select class="amplify-select amplify-field-group__control" id="klas" formControlName="klas" [(ngModel)]="selectedClassId">
        <option *ngFor="let klas of classOptions" [value]="klas.id">{{ klas.name }}</option>
      </select>
    </div>

    <div class="form-group" *ngIf="isTeacher">
      <label class="amplify-label" for="stamboek">stamboeknummer</label>
      <input type="text" class="amplify-input" id="stamboek" formControlName="stamboek">
    </div>

    <div class="form-group buttons">
      <button class="amplify-button amplify-button--fullwidth amplify-button--medium amplify-button--primary" type="submit" [disabled]="!isValid">Verbind mij met deze school</button>
      <button class="amplify-button amplify-button--fullwidth amplify-button--medium amplify-button--destructive" (click)="cancel()">Annuleer</button>
    </div>
  </form>
</div>

